import React from 'react'
import { contact } from '../../../content/site'

// Contact hero, on the new design system (Task 10). Same dark .hero-section treatment as
// About, Services and FAQ (reuses .about-hero-inner's single-column grid override verbatim)
// so all four read as siblings, per the task brief. Title and paragraph are copied verbatim
// from the old src/pages/public/contact/hero.jsx (git 06da2a1) - no eyebrow existed there,
// so none is invented here, same reasoning FAQ's hero followed.
//
// The old hero also carried a decorative photograph (images/public/15.png, alt="FAQ Hero" -
// a pre-existing copy-paste mismatch from the old FAQ hero, not this page's own asset) next
// to the text in a two-column row. It is dropped here: About/Services/FAQ's shared dark hero
// pattern is single-column/text-only by design, the image carried no copy of its own, and the
// task brief calls for this page to read as a sibling of those three.
const Hero = () => {
  return (
    <section className="hero-section">
      <div className="hero about-hero-inner">
        <h1>{contact.hero.title}</h1>
        <p className="hero-desc about-hero-desc">{contact.hero.paragraph}</p>
      </div>
    </section>
  )
}

export default Hero
